var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[(_vm.isLogged)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logOut()}}},[_vm._v(" "+_vm._s(_vm.$t('buttons.logout'))+" ")]):_c('router-link',{staticClass:"ml-3",attrs:{"to":{ name: 'login' }}},[_vm._v(" "+_vm._s(_vm.$t('menu.login'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }